export { EmbeddedLink } from "./EmbeddedLink";
export type { EmbeddedLinkProps, IEmbeddedLinkTheme } from "./types";
